<template lang="html">
  <Row type="flex">
    <Col span="20">
      <h3>{{ title }}</h3>
    </Col>
    <Col span="4">
      <Row type="flex" align="middle" justify="end">
        <Icon type="more"></Icon>
      </Row>
    </Col>
  </Row>
</template>

<script>
export default {
  props: { title: String },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/CardHeader.vue